import axios from "@/plugins/axios";

let url = (data) => "/api/v1/person/meetings/${_meeting}/schedule".interpolate(data);

export default {
    get(data) {
        return axios.get(url(data)).then((result) => result.data);
    },
    post(data) {
        return axios.post(url(data), data).then((result) => result.data);
    },
    put(data) {
        return axios.put(url(data), data).then((result) => result.data);
    },
};
